module.exports = __webpack_public_path__ + "img/vippack_dfod_dg_k.1609d980.png";